import { isValidEventSlug } from "@shared/utils/eventIdValidation";

export const PENDING_EVENT_ID_STORAGE_KEY = "pendingEventId";

export function persistPendingEventId(eventId: string): string | null {
  const trimmed = eventId.trim();
  if (!isValidEventSlug(trimmed)) {
    return null;
  }
  sessionStorage.setItem(PENDING_EVENT_ID_STORAGE_KEY, trimmed);
  return trimmed;
}

export function readPendingEventId(): string | null {
  const stored = sessionStorage.getItem(PENDING_EVENT_ID_STORAGE_KEY)?.trim();
  if (!stored || !isValidEventSlug(stored)) {
    return null;
  }
  return stored;
}

export function clearPendingEventIdStorage(): void {
  sessionStorage.removeItem(PENDING_EVENT_ID_STORAGE_KEY);
}
